
export default [{}, {
  orgInfo: {
    CUST_FNAME: "userFname",
    ID_TYPE: "idType",
    ID_CODE: "idCode",
    ID_EXP_DATE: "idExpDate",
    ID_ADDR: "address",
    ORG_ID_CODE: "orgIdCode",
    REGISTER_FUND: "registerFund",
    REGISTER_CURRENCY: "registerCurrency",
    SZORG_TYPE: "szorgtype",
    LEGAL_REP: "legpRep",
    LEGAL_REP_ID_TYPE: "legalRepIdType",
    LEGAL_REP_ID_CODE: "legalRepIdCode",
    LEGAL_REP_ID_EXP_DATE: "legalRepIdExpDate",
    BUSINESS_TAX_NO: "taxNo",
    LAND_TAX_NO: "taxNo",
    BUSINESS_RANGE: "businessRange",
    INDUS_GB: "trade" },
  otherInfo: {
    BENEFIT_LIST: "beneficiaryInfoList",
    beneficiaryInfoList: {
      BENEFICIARY_NAME: "beneficiaryName",
      BENEFICIARY_ID_TYPE: "beneficiaryIdType",
      BENEFICIARY_ID: "beneficiaryId",
      BENEFICIARY_EXP_DATE: "beneficiaryExpDate",
      BENEFICIARY_ADDR: "beneficiaryAddr",
      BENEFICIARY_TYPE: "beneficiaryType",
      SHARE_RATIO: "shareRatio" },

    CONTROL_LIST_1: "controllerInfoDtoList",
    controllerInfoDtoList: {
      CONTROLER_NAME: "controller",
      CONTROLER_ID_TYPE: "controllerIdType",
      CONTROLER_ID_NO: "controllerIdCode",
      CONTROLER_ID_EXP_DATE: "controllerIdExpDate" }
  },
  agentInfo: {
    AGENT_CUST_FNAME: "agentName",
    AGENT_ID_TYPE: "agentIdType",
    AGENT_ID_CODE: "agentIdCode",
    AGENT_ID_EXP_DATE: "agentIdExpDate",
    TEL: "agentTel",
    MOBILE_TEL: "agentMobileTel",
    OFFICE_TEL: "agentOfficeTel" }
}, {
  baseInfo: {
    PRO_NAME: "proName",
    PRO_SNAME: "proSname",
    ID_TYPE: "idType",
    ID_CODE: "idCode",
    PRO_CLS: "proCls",
    PRO_BAK_CODE: "proCode",
    PRO_EXP_DATE: "proExpDate",
    BENEFIT_LIST: "beneficiaryInfoList",
    beneficiaryInfoList: {
      BENEFICIARY_NAME: "beneficiaryName",
      BENEFICIARY_ID_TYPE: "beneficiaryIdType",
      BENEFICIARY_ID: "beneficiaryId",
      BENEFICIARY_EXP_DATE: "beneficiaryExpDate",
      BENEFICIARY_ADDR: "beneficiaryAddr",
      BENEFICIARY_TYPE: "beneficiaryType",
      SHARE_RATIO: "shareRatio" }
  },
  managerInfo: {
    PRO_MANAGER_NAME: "proManagerName",
    PRO_MANAGER_ID_TYPE: "proManagerIdType",
    PRO_MANAGER_ID_CODE: "proManagerIdCode",
    PRO_MANAGER_ID_EXP_DATE: "proManagerIdExpDate",
    SZORG_TYPE: "szorgtype",
    BUSINESS_RANGE: "businessRange",
    OFFICE_ADDR: "address",
    REGISTER_FUND: "registerFund",
    REGISTER_CURRENCY: "registerCurrency",
    INDUS_GB: "indusType",
    LEGAL_REP: "legalRep",
    LEGAL_REP_ID_TYPE: "legalRepIdType",
    LEGAL_REP_ID_CODE: "legalRepIdCode",
    LEGAL_REP_ID_EXP_DATE: "legalRepIdExpDate",
    CONTROL_LIST_1: "controllerInfoDtoList",
    controllerInfoDtoList: {
      CONTROLER_NAME: "controller",
      CONTROLER_ID_TYPE: "controllerIdType",
      CONTROLER_ID_NO: "controllerIdCode",
      CONTROLER_ID_EXP_DATE: "controllerIdExpDate" }
  },

  agentInfo: {
    AGENT_CUST_FNAME: "agentName",
    AGENT_ID_TYPE: "agentIdType",
    AGENT_ID_CODE: "agentIdCode",
    AGENT_ID_EXP_DATE: "agentIdExpDate",
    TEL: "agentTel",
    MOBILE_TEL: "agentMobileTel",
    OFFICE_TEL: "agentOfficeTel" }
}];


//////////////////
// WEBPACK FOOTER
// ./src/business/businessTools/ecif-param-relationship.js
// module id = 1620
// module chunks = 2